import { motion } from "framer-motion";
import { FAQS } from "@/data/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32 border-t border-bp-border">
      <div className="mx-auto max-w-3xl px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <span className="text-sm text-bp-primary uppercase tracking-[0.2em] font-semibold">Preguntas frecuentes</span>
          <h2 className="font-heading text-3xl lg:text-5xl font-semibold tracking-tight mt-4">
            Resolvemos tus dudas
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-bp-border bg-bp-surface px-6 data-[state=open]:border-bp-primary/40"
            >
              <AccordionTrigger className="text-left font-heading text-base lg:text-lg font-medium text-white hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#A3A3A3] text-sm leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
